import * as angular from 'angular';

"use strict";
angular.module('complianceCtrl', []);

export default 'complianceCtrl'